import React from 'react';
import clsx from 'clsx';
import ButtonSection from './ButtonSection';
import ListItemSection from './ListItemSection';
import MediaDesktop, { MediaMobile } from './MediaSection';
import DisclaimerSection from './DisclaimerSection';
import HeadingAndDescriptionSection from './HeadingAndDescriptionSection';
import { PhotoAndTextCardFieldsFragment } from '../../../@types/generated';
import SlideIn from '../Transitions/SlideIn';

type Props = {
  data: PhotoAndTextCardFieldsFragment;
};

const PhotoAndTextCard = ({ data }: Props) => {
  return (
    <div key={data.id} className="col-span-full md:col-span-12 md:col-start-2 md:grid md:grid-cols-12">
      <MediaMobile data={data} />
      {data.imagePosition === 'left' && <MediaDesktop data={data} />}
      <div
        className={`col-span-6 self-center md:pl-24 md:pr-24 ${
          data.imagePosition !== 'right' ? 'lg:ml-48' : 'lg:mr-48'
        } ${clsx({
          'md:col-start-7': data.imagePosition === 'left',
        })}`}
      >
        <SlideIn>
          <HeadingAndDescriptionSection data={data} />
          <ListItemSection data={data} />
        </SlideIn>
        <ButtonSection data={data} />
      </div>
      {data.imagePosition === 'right' && <MediaDesktop data={data} />}
      <DisclaimerSection data={data} />
    </div>
  );
};
export default PhotoAndTextCard;
